module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[119]240.0c047cd.woff2";